export default function Footer() {
  return (
    <footer id="footer" className="bg-background-100 border-t border-background-200/60">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="max-w-[1280px] mx-auto">
          <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-5 gap-8 mb-10">
            <div className="col-span-2 sm:col-span-1 lg:col-span-1">
              <a href="#hero" className="flex items-center gap-2 mb-4">
                <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500">
                  <i className="ri-movie-2-fill text-background-50 text-base"></i>
                </div>
                <span className="font-heading text-lg text-foreground-950 whitespace-nowrap">人人影院</span>
              </a>
              <p className="text-xs text-foreground-600 leading-relaxed">
                免费高清在线观看平台，提供最新电影、电视剧全集在线观看服务，海量影视资源每日更新，流畅播放不缓冲。
              </p>
            </div>

            <div>
              <h4 className="text-sm font-medium text-foreground-950 mb-3">热门分类</h4>
              <ul className="space-y-2">
                <li><a href="#index" className="text-xs text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">动作片</a></li>
                <li><a href="#index" className="text-xs text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">喜剧片</a></li>
                <li><a href="#index" className="text-xs text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">悬疑片</a></li>
                <li><a href="#index" className="text-xs text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">科幻片</a></li>
                <li><a href="#index" className="text-xs text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">爱情片</a></li>
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-medium text-foreground-950 mb-3">快速导航</h4>
              <ul className="space-y-2">
                <li><a href="#ranking" className="text-xs text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">热播榜单</a></li>
                <li><a href="#carousel" className="text-xs text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">精选专题</a></li>
                <li><a href="#media" className="text-xs text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">精彩预告</a></li>
                <li><a href="#faq" className="text-xs text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">常见问题</a></li>
                <li><a href="#app" className="text-xs text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">移动观影</a></li>
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-medium text-foreground-950 mb-3">关于我们</h4>
              <ul className="space-y-2">
                <li><a href="#about" className="text-xs text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">品牌介绍</a></li>
                <li><a href="#contact" className="text-xs text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">联系我们</a></li>
                <li><a href="#features" className="text-xs text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">平台优势</a></li>
                <li><a href="#updates" className="text-xs text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">最新动态</a></li>
              </ul>
            </div>

            <div className="col-span-2 sm:col-span-1">
              <h4 className="text-sm font-medium text-foreground-950 mb-3">合作伙伴</h4>
              <p className="text-xs text-foreground-600 leading-relaxed">
                诚邀各大影视平台、内容制作方及品牌方合作，共同打造优质观影生态。
              </p>
            </div>
          </div>

          <div className="flex flex-col sm:flex-row items-center justify-between gap-4 pt-8 border-t border-background-200/60">
            <p className="text-xs text-foreground-600">
              &copy; 2020-2026 人人影院 版权所有 | 免费高清在线观看平台
            </p>
            <div className="flex items-center gap-4">
              <a href="#hero" className="text-xs text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">服务条款</a>
              <a href="#hero" className="text-xs text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">隐私政策</a>
              <a href="#hero" className="text-xs text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">版权声明</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}